module.exports = __webpack_public_path__ + "src/app/_content/MINIFonts/mini_serif-regular-web.woff?71363b8e7a8892393b49b166c31f78d7";